export const completionLinks = {
  paid: "https://connect.cloudresearch.com/participant/project/D15AE72961/complete",
  unpaid: "https://connect.cloudresearch.com/participant/project/A32AAB039E/complete",
  partial: "https://connect.cloudresearch.com/participant/project/B84DF78A93/complete",
};
